document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.reference').forEach(ref => {
        ref.addEventListener('click', function() {
            const refNum = this.dataset.ref;
            const source = document.getElementById(`source-${refNum}`);
            if (source) {
                source.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

    document.querySelectorAll('.source').forEach(source => {
        source.addEventListener('click', function() {
            const refNum = this.dataset.ref;
            const ref = document.getElementById(`ref-${refNum}`);
            if (ref) {
                ref.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
});
